import { render, staticRenderFns } from "./treatmentList.vue?vue&type=template&id=edc977f8&scoped=true"
import script from "./treatmentList.vue?vue&type=script&lang=js"
export * from "./treatmentList.vue?vue&type=script&lang=js"
import style0 from "./treatmentList.vue?vue&type=style&index=0&id=edc977f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc977f8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TreatmentListItem: require('/salonhomepage/client/components/TreatmentListItem.vue').default})
